/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.18.0
 * @since 1.17.0
 */

import { useFormikContext } from 'formik';

import RadioButton, { IRadioButtonProps } from '../../../components/common/RadioButton/RadioButton';
import FormField, { IFormFieldProps } from './FormField';

type TFormFieldRadioButton = IFormFieldProps & Partial<IRadioButtonProps> & { value: string; };

const FormFieldRadioButton = (props: TFormFieldRadioButton) => {
    const { setFieldValue } = useFormikContext();

    return (
        <FormField {...props}>
            {({ field, disabled, label, dataName }) => {
                const onChange = () => {
                    setFieldValue(field.name, props.value);
                };

                return (
                    <RadioButton
                        {...field}
                        checked={field.value === props.value}
                        dataName={dataName}
                        disabled={disabled}
                        label={label}
                        onChange={onChange}
                    />
                );
            }}
        </FormField>
    );
}

export default FormFieldRadioButton;
